<template>
  <div class="absolute inset-0 bg-white/75 z-50" />
</template>
